import React, {useState} from "react";
import CategorySelection from "./CategorySelection/CategorySelection";
import PostDetails from "./PostDetails/PostDetails";
import {MobileContainer} from "../../Global/Global";
import {useLocation} from "react-router-dom";

export const CreatePost = () => {
    const location = useLocation();

    const path = location.pathname;  // e.g. /opret-annonce/1
    const isRemote = path.split("/")[1] == "rediger-annonce";
    const hasCategory = /^\/opret-annonce\/\d+$/.test(path) || isRemote;  // '/opret-annonce/123'

    return <>
        <MobileContainer>
            <h1>Min annonce</h1>
        </MobileContainer>
        {hasCategory ? <PostDetails /> : <CategorySelection />}
    </>
}